// extracted by mini-css-extract-plugin
export default {"popover":"popover_popover__4ygbT","MuiPopover-paper":"popover_MuiPopover-paper__nUIcK","text":"popover_text__75v-M"};